import { cn } from '@utils/cn';
import { type ComponentProps } from 'react';

const TimeLineHeader = ({
  className,
  children,
  ...props
}: ComponentProps<'header'>) => {
  return (
    <header className={cn(className)} {...props}>
      {children}
    </header>
  );
};

export { TimeLineHeader };
